__turbopack_context__.v({
  "errorButton": "TeamLogin-module-scss-module__VU4DGq__errorButton",
  "errorState": "TeamLogin-module-scss-module__VU4DGq__errorState",
  "errorStateAdditionalMessage": "TeamLogin-module-scss-module__VU4DGq__errorStateAdditionalMessage",
  "errorStateBigMessage": "TeamLogin-module-scss-module__VU4DGq__errorStateBigMessage",
  "errorStateDivider": "TeamLogin-module-scss-module__VU4DGq__errorStateDivider",
  "errorStateLogo": "TeamLogin-module-scss-module__VU4DGq__errorStateLogo",
  "errorStateMessage": "TeamLogin-module-scss-module__VU4DGq__errorStateMessage",
});
